import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const ResultPage = ({ userAnswers, onRestart, onOpenAudio }) => {
    const total = userAnswers.length;
    const correctCount = userAnswers.filter((a) => a.isCorrect).length;
    const scorePercent = Math.round((correctCount / total) * 100);

    const formatTime = (seconds) => {
        if (seconds < 60) return `${seconds}s`;
        const minutes = Math.floor(seconds / 60);
        const remaining = seconds % 60;
        return `${minutes}m ${remaining}s`;
    };


    const getColor = () => {
        if (scorePercent <= 35) return "#ff4d4f";   // red
        if (scorePercent <= 69) return "#faad14";   // yellow
        return "#52c41a";                           // green
    };


    return (
        <div className="container result-container">
            <h1 className="title">🚔 Quiz Result</h1>

            <div className="score-circle">
                <div style={{ width: 150, height: 150 }}>
                    <CircularProgressbar
                        value={scorePercent}
                        text={`${scorePercent}%`}
                        styles={buildStyles({
                            textColor: getColor(),
                            pathColor: getColor(),
                            trailColor: "#eee",
                            textSize: "20px",
                        })}
                    />
                </div>
            </div>

            <p className="score-summary">
                You got <strong>{correctCount}</strong> out of <strong>{total}</strong> correct
            </p>

            <h2 className="review-title">Detailed Review</h2>

            <div className="review-grid">
                {userAnswers.map((ans, index) => (
                    <div key={index} className="review-card">
                        <div className="review-header">
                            <span className="question-number">Question {index + 1}</span>
                            <span className={`status-badge ${ans.isCorrect ? "correct" : "wrong"}`}>
                                {ans.isCorrect ? "✅ Correct" : "❌ Incorrect"}
                            </span>
                        </div>

                        <h3 className="review-question">{ans.question}</h3>

                        <div className="answer-row">
                            <div>Your Answer: <span className={ans.isCorrect ? "correct-text" : "wrong-text"}>{ans.selected}</span></div>
                            {!ans.isCorrect && (
                                <div>Correct Answer: <span className="correct-text">{ans.correct}</span></div>
                            )}
                        </div>

                        <div className="time-row">
                            Time Taken: <strong>{formatTime(ans.timeTaken)}</strong>
                        </div>

                        {ans.expaudio && (
                            <button
                                className="btn audio"
                                onClick={() => onOpenAudio(ans.expaudio)}
                            >
                                🔊 Listen Explanation
                            </button>
                        )}

                        {index < userAnswers.length - 1 && <div className="divider" />}
                    </div>
                ))}
            </div>

            <button className="btn restart" onClick={onRestart}>
                Back to Dashboard
            </button>
        </div>
    );
};

export default ResultPage;